<script>
  import SingleHeader from "./SingleHeader.svelte";
  import MultiHeader from "./MultiHeader.svelte";
  import { feeds, account } from "../stores.js";
  import Loader from "./Loader.svelte";
</script>

{#await $feeds}
  <Loader />
{:then feeds}
  {#if feeds.length > 1 && $account}
    <MultiHeader account={$account} {feeds} />
  {:else if feeds.length === 1}
    <SingleHeader
      compact={false}
      podcast={feeds[0].metadata}
      cover={feeds[0].files
        .filter((d) => d.format.match(/JPG|JPEG|PNG|GIF|Item Image/gm))
        .sort((a, b) => {
          if (a.format === 'Item Image' && b.format !== 'Item Image') {
            return -1;
          } else if (b.format === 'Item Image' && a.format !== 'Item Image') {
            return 1;
          } else {
            return 0;
          }
        })[0]} />
  {:else}
    <div class="alert alert-warning mt-3" role="alert">
      <p>
        Non hai inserito
        <code>feeds</code>
        o
        <code>account</code>
        correttamente nel tuo file di configurazione!
      </p>
    </div>
  {/if}
{:catch}
  <div class="alert alert-danger mt-3" role="alert">
    <p>Qualcosa è andato storto!</p>
  </div>
{/await}
